<div [hidden]="!show">
    <div class="progress-loader"></div>
</div>

<div [hidden]="!secondLoder">
    <div class="spinner-loader">
        <i class="fa fa-spinner fa-spin fa-4x center-loader"></i>
    </div>
</div>